import React from 'react';
import NavLink from './NavLink';
import Dropdown from './Dropdown';
import messages from './messages';
import { home } from './groups';
import { FaHome } from 'react-icons/all';

const HomeDropdown = ({ closeSidebar }) => (
  <Dropdown icon={<FaHome />} label={messages.home_screen}>
    {home.map((item, index) => (
      <NavLink
        key={index}
        name={item.name}
        icon={item.icon}
        route={item.url}
        role={item.role}
        module={item.module}
        closeSidebar={closeSidebar}
      />
    ))}
  </Dropdown>
);

export default HomeDropdown;
